import React, { useState, useEffect } from "react";
import AOS from "aos";
import "aos/dist/aos.css";
import { FaEnvelope, FaTimes } from "react-icons/fa";
import "./PlanaDocente.css";

//  Importa foto de perfil
import defaultPhoto from "../assets/nosotros/plana_docente/perfil.jpg";
import azahuanche from "../assets/nosotros/plana_docente/azahuanche.jpg";
import medina from "../assets/nosotros/plana_docente/medina.jpg";
import zuñiga from "../assets/nosotros/plana_docente/zuñiga.jpg";
import apari from "../assets/nosotros/plana_docente/apari.jpg";
import galvez from "../assets/nosotros/plana_docente/galvez.jpg";
import gutierrez from "../assets/nosotros/plana_docente/gutierrez.jpg";
import huanasca from "../assets/nosotros/plana_docente/huanasca.jpg";
import huanca from "../assets/nosotros/plana_docente/huanca.jpg";
import monares from "../assets/nosotros/plana_docente/monares.jpg";
import padilla from "../assets/nosotros/plana_docente/padilla.jpg";
import ferro from "../assets/nosotros/plana_docente/ferro.jpg";
import huailla from "../assets/nosotros/plana_docente/huailla.jpg";
import meza from "../assets/nosotros/plana_docente/meza.jpg";
import negron from "../assets/nosotros/plana_docente/negron.jpg";
import ramirez from "../assets/nosotros/plana_docente/ramirez.jpg";
import razo from "../assets/nosotros/plana_docente/razo.jpg";
import huaracha from "../assets/nosotros/plana_docente/huaracha.jpg";
import quihui from "../assets/nosotros/plana_docente/quihui.jpg";
import cabrera from "../assets/nosotros/plana_docente/cabrera.jpg";
import palomares from "../assets/nosotros/plana_docente/palomares.jpg";
import pillaca from "../assets/nosotros/plana_docente/pillaca.jpg";
import rojas from "../assets/nosotros/plana_docente/rojas.jpg";
import lucas from "../assets/nosotros/plana_docente/lucas.jpg";
import fernandez1 from "../assets/nosotros/plana_docente/fernandez1.jpg";
import ynguil from "../assets/nosotros/plana_docente/ynguil.jpg";
import hernandez from "../assets/nosotros/plana_docente/hernandez.jpg";
import miranda from "../assets/nosotros/plana_docente/miranda.jpg";
import domenica from "../assets/nosotros/plana_docente/domenica.jpg";
import vilchez_medina from "../assets/nosotros/plana_docente/vilchez_medina.jpg";
import viera from "../assets/nosotros/plana_docente/viera.jpg";
import ochoa from "../assets/nosotros/plana_docente/ochoa.jpg";
import osco from "../assets/nosotros/plana_docente/osco.jpg";
import becerra from "../assets/nosotros/plana_docente/becerra.jpg";
import luyo from "../assets/nosotros/plana_docente/luyo.jpg";
import alejo from "../assets/nosotros/plana_docente/alejo.jpg";
import gutierrez_c from "../assets/nosotros/plana_docente/gutierrez_c.jpg";
import suarez from "../assets/nosotros/plana_docente/suarez.jpg";
import soria from "../assets/nosotros/plana_docente/soria.jpg";
import sosa from "../assets/nosotros/plana_docente/sosa.jpg";
import ramos from "../assets/nosotros/plana_docente/ramos.jpg";
import calderon from "../assets/nosotros/plana_docente/calderon.jpg";
import unsihuay from "../assets/nosotros/plana_docente/unsihuay.jpg";
import pernia from "../assets/nosotros/plana_docente/pernia.jpg";
import nosser from "../assets/nosotros/plana_docente/nosser.jpg";
import teran from "../assets/nosotros/plana_docente/teran.jpg";
import carhuancho from "../assets/nosotros/plana_docente/carhuancho.jpg";
import pujay from "../assets/nosotros/plana_docente/pujay.jpg";
import acaro from "../assets/nosotros/plana_docente/acaro.jpg";
import neil from "../assets/nosotros/plana_docente/neil.jpg";
import nolasco from "../assets/nosotros/plana_docente/nolasco.jpg";
import lagos from "../assets/nosotros/plana_docente/lagos.jpg";
import auloinga from "../assets/nosotros/plana_docente/auloinga.jpg";
import carrascolinares from "../assets/nosotros/plana_docente/carrascolinares.jpg";
import chipana from "../assets/nosotros/plana_docente/chipana.jpg";
import gallardolopez from "../assets/nosotros/plana_docente/gallardolopez.jpg";
import herrera from "../assets/nosotros/plana_docente/herrera.jpg";
import perezmendoza from "../assets/nosotros/plana_docente/perezmendoza.jpg";
import ruiz from "../assets/nosotros/plana_docente/ruiz.jpg";
import solano from "../assets/nosotros/plana_docente/solano.jpg";
import velasquezcabanillas from "../assets/nosotros/plana_docente/velasquezcabanillas.jpg";
import villavicencio from "../assets/nosotros/plana_docente/villavicencio.jpg";
import pareja from "../assets/nosotros/plana_docente/pareja.jpg";
import palomino from "../assets/nosotros/plana_docente/palomino.jpg";
import zarate from "../assets/nosotros/plana_docente/zarate.jpg";
import rojascahua from "../assets/nosotros/plana_docente/rojascahua.jpg";
import mamani from "../assets/nosotros/plana_docente/mamani.jpg";
import huarhua from "../assets/nosotros/plana_docente/huarhua.jpg";
import huaccha from "../assets/nosotros/plana_docente/huaccha.jpg";
import guerra from "../assets/nosotros/plana_docente/guerra.jpg";
import gaspar from "../assets/nosotros/plana_docente/gaspar.jpg";
import gallardo from "../assets/nosotros/plana_docente/gallardo.jpg";
import estrada from "../assets/nosotros/plana_docente/estrada.jpg";
import bastidas from "../assets/nosotros/plana_docente/bastidas.jpg";
import yaya from "../assets/nosotros/plana_docente/yaya.jpg";
import eyzaguirre from "../assets/nosotros/plana_docente/eyzaguirre.jpg";
import guillenrojas from "../assets/nosotros/plana_docente/guillenrojas.jpg";
import moreno from "../assets/nosotros/plana_docente/moreno.jpg";
import olivares from "../assets/nosotros/plana_docente/olivares.jpg";
import mera from "../assets/nosotros/plana_docente/mera.jpg";
import camargo from "../assets/nosotros/plana_docente/camargo.jpg";
import pazsoldan from "../assets/nosotros/plana_docente/pazsoldan.jpg";
import portal from "../assets/nosotros/plana_docente/portal.jpg";
import villavicencioriveros from "../assets/nosotros/plana_docente/villavicencioriveros.jpg";
import choque from "../assets/nosotros/plana_docente/choque.jpg";
import cortez from "../assets/nosotros/plana_docente/cortez.jpg";




//  Importa los CV en PDF
import AZAHUANCHE from "../assets/nosotros/plana_docente/AZAHUANCHE.pdf";
import MEDINA from "../assets/nosotros/plana_docente/MEDINA.pdf";
import ZUÑIGA from "../assets/nosotros/plana_docente/ZUÑIGA.pdf";
import APARI from "../assets/nosotros/plana_docente/APARI.pdf";
import KARINA from "../assets/nosotros/plana_docente/KARINA.pdf";
import GUTIERREZ from "../assets/nosotros/plana_docente/GUTIERREZ.pdf";
import HUANASCA from "../assets/nosotros/plana_docente/HUANASCA.pdf";
import HUANCA from "../assets/nosotros/plana_docente/HUANCA.pdf";
import MONARES from "../assets/nosotros/plana_docente/MONARES.pdf";
import PADILLA from "../assets/nosotros/plana_docente/PADILLA.pdf";
import FERRO from "../assets/nosotros/plana_docente/FERRO.pdf";
import HUAILLA from "../assets/nosotros/plana_docente/HUAILLA.pdf";
import MEZA from "../assets/nosotros/plana_docente/MEZA.pdf";
import NEGRON from "../assets/nosotros/plana_docente/NEGRON.pdf";
import RAMIREZ from "../assets/nosotros/plana_docente/RAMIREZ.pdf";
import RAZO from "../assets/nosotros/plana_docente/RAZO.pdf";
import HUARACHA from "../assets/nosotros/plana_docente/HUARACHA.pdf";
import QUIHUI from "../assets/nosotros/plana_docente/QUIHUI.pdf";
import CABRERA from "../assets/nosotros/plana_docente/CABRERA.pdf";
import PALOMARES from "../assets/nosotros/plana_docente/PALOMARES.pdf";
import PILLACA from "../assets/nosotros/plana_docente/pillaca.pdf";
import ROJAS from "../assets/nosotros/plana_docente/ROJAS.pdf";
import Carhuancho from "../assets/nosotros/plana_docente/Carhuancho.pdf";
import Pujay from "../assets/nosotros/plana_docente/Pujay.pdf";
import Ramos_Rojas from "../assets/nosotros/plana_docente/Ramos_Rojas.pdf";
import Vilchez_Cordova from "../assets/nosotros/plana_docente/Vilchez_Cordova.pdf";
import Vilchez_Medina from "../assets/nosotros/plana_docente/Vilchez_Medina.pdf";
import Villavicencio from "../assets/nosotros/plana_docente/Villavicencio.pdf";
import Lucas from "../assets/nosotros/plana_docente/Lucas.pdf";
import FERNANDEZ from "../assets/nosotros/plana_docente/FERNANDEZ.pdf";
import YNGUIL from "../assets/nosotros/plana_docente/YNGUIL.pdf";
import HERNANDEZ from "../assets/nosotros/plana_docente/HERNANDEZ.pdf";
import CHIPANA from "../assets/nosotros/plana_docente/CHIPANA.pdf";
import MIRANDA from "../assets/nosotros/plana_docente/MIRANDA.pdf";
import DOMENICA from "../assets/nosotros/plana_docente/DOMENICA.pdf";
import VIERA from "../assets/nosotros/plana_docente/VIERA.pdf";
import OCHOA from "../assets/nosotros/plana_docente/OCHOA.pdf";
import OSCO from "../assets/nosotros/plana_docente/OSCO.pdf";
import BECERRA from "../assets/nosotros/plana_docente/BECERRA.pdf";
import LUYO from "../assets/nosotros/plana_docente/LUYO.pdf";
import ALEJO from "../assets/nosotros/plana_docente/ALEJO.pdf";
import GUTIERREZ_C from "../assets/nosotros/plana_docente/GUTIERREZ_C.pdf";
import SUAREZ from "../assets/nosotros/plana_docente/SUAREZ.pdf";
import SORIA from "../assets/nosotros/plana_docente/SORIA.pdf";
import SOSA from "../assets/nosotros/plana_docente/SOSA.pdf";
import RAMOS from "../assets/nosotros/plana_docente/RAMOS.pdf";
import CALDERON from "../assets/nosotros/plana_docente/CALDERON.pdf";
import UNSIHUAY from "../assets/nosotros/plana_docente/UNSIHUAY.pdf";
import PERNIA from "../assets/nosotros/plana_docente/PERNIA.pdf";
import NOSSER from "../assets/nosotros/plana_docente/NOSSER.pdf";
import TERAN from "../assets/nosotros/plana_docente/TERAN.pdf";
import ACARO from "../assets/nosotros/plana_docente/ACARO.pdf";
import RUIZ from "../assets/nosotros/plana_docente/RUIZ.pdf";
import NEIL from "../assets/nosotros/plana_docente/NEIL.pdf";
import CAMARGO from "../assets/nosotros/plana_docente/CAMARGO.pdf";
import NOLASCO from "../assets/nosotros/plana_docente/NOLASCO.pdf";
import LAGOS from "../assets/nosotros/plana_docente/LAGOS.pdf";
import AULOINGA from "../assets/nosotros/plana_docente/AULOINGA.pdf";
import CARRASCOLINARES from "../assets/nosotros/plana_docente/CARRASCOLINARES.pdf";
import GALLARDOLOPEZ from "../assets/nosotros/plana_docente/GALLARDOLOPEZ.pdf";
import HERRERA from "../assets/nosotros/plana_docente/HERRERA.pdf";
import PEREZMENDOZA from "../assets/nosotros/plana_docente/PEREZMENDOZA.pdf";
import SOLANO from "../assets/nosotros/plana_docente/SOLANO.pdf";
import VELASQUEZCABANILLAS from "../assets/nosotros/plana_docente/VELASQUEZCABANILLAS.pdf";
import PAREJA from "../assets/nosotros/plana_docente/PAREJA.pdf";
import PALOMINO from "../assets/nosotros/plana_docente/PALOMINO.pdf";
import ZARATE from "../assets/nosotros/plana_docente/ZARATE.pdf";
import VLADIMIR from "../assets/nosotros/plana_docente/VLADIMIR.pdf";
import ROJASCAHUA from "../assets/nosotros/plana_docente/ROJASCAHUA.pdf";
import MAMANI from "../assets/nosotros/plana_docente/MAMANI.pdf";
import HUARHUA from "../assets/nosotros/plana_docente/HUARHUA.pdf";
import HUACCHA from "../assets/nosotros/plana_docente/HUACCHA.pdf";
import GUERRA from "../assets/nosotros/plana_docente/Guerra.pdf";
import GASPAR from "../assets/nosotros/plana_docente/GASPAR.pdf";
import GALLARDO from "../assets/nosotros/plana_docente/GALLARDO.pdf";
import ESTRADA from "../assets/nosotros/plana_docente/ESTRADA.pdf";
import BASTIDAS from "../assets/nosotros/plana_docente/Bastidas.pdf";
import YAYA from "../assets/nosotros/plana_docente/YAYA.pdf";
import EYZAGUIRRE from "../assets/nosotros/plana_docente/EYZAGUIRRE.pdf";
import GUILLENROJAS from "../assets/nosotros/plana_docente/GUILLENROJAS.pdf";
import MORENO from "../assets/nosotros/plana_docente/MORENO.pdf";
import OLIVARES from "../assets/nosotros/plana_docente/OLIVARES.pdf";
import MERA from "../assets/nosotros/plana_docente/MERA.pdf";
import CHOQUE from "../assets/nosotros/plana_docente/CHOQUE.pdf";
import PAZSOLDAN from "../assets/nosotros/plana_docente/PAZSOLDAN.pdf";
import PORTAL from "../assets/nosotros/plana_docente/PORTAL.pdf";
import TALLA from "../assets/nosotros/plana_docente/TALLA.pdf";
import GUILLEN from "../assets/nosotros/plana_docente/GUILLEN.pdf";
import VILLAVICENCIORIVEROS from "../assets/nosotros/plana_docente/VILLAVICENCIORIVEROS.pdf";
import CORTEZ from "../assets/nosotros/plana_docente/CORTEZ.pdf";
import PONCE from "../assets/nosotros/plana_docente/PONCE.pdf";


const docentesData = {

"Gestión Administrativa": [
    
    { nombre: "LUCAS TAMAYO SIDNEY ERICO", correo: "lucas.sidney@iestpgildaballivian.edu.pe", foto: lucas, pdf: Lucas },  
    { nombre: "BECERRA BRINGAS MIGUEL ANGEL", correo: "becerra.miguel@iestpgildaballivian.edu.pe", foto: becerra, pdf: BECERRA },    
    { nombre: "LUYO VENEGAS RUTH", correo: "luyo.ruth@iestpgildaballivian.edu.pe", foto: luyo, pdf: LUYO },
    { nombre: "MIRANDA GONZALES NEL MARTIN", correo: "miranda.nel@iestpgildaballivian.edu.pe", foto: miranda, pdf: MIRANDA },
    { nombre: "NEGRON ALVARADO ELMER AUGURIO", correo: "negron.elmer@iestpgildaballivian.edu.pe", foto: negron, pdf:NEGRON},    
    { nombre: "RAMIREZ CHUQUIHUANGA LUIS ALBERTO", correo: "ramirez.luis@iestpgildaballivian.edu.pe", foto: ramirez, pdf: RAMIREZ },
    { nombre: "RAZO QUISPE JOSE LUIS", correo: "razo.jose@iestpgildaballivian.edu.pe", foto: razo, pdf: RAZO},
    { nombre: "VILCHEZ MEDINA WALTER ARMANDO", correo: "vilchez.walter@iestpgildaballivian.edu.pe", foto: vilchez_medina, pdf:Vilchez_Medina },
    { nombre: "YNGUIL FERNANDEZ WILLIAN MARTIN", correo: "ynguil.william@iestpgildaballivian.edu.pe", foto: ynguil, pdf: YNGUIL },
    { nombre: "VIERA CHALLE PAULO OMAR ", correo: "viera.paulo@iestpgildaballivian.edu.pe", foto: viera, pdf: VIERA },
    { nombre: "OCHOA QUISPE WALTER VALENTIN", correo: "ochoa.walter@iestpgildaballivian.edu.pe", foto: ochoa, pdf: OCHOA },
  ],

  "Contabilidad": [
    
    { nombre: "QUISPE DIAZ DOMENICA AGRIPINA", correo: "quispe.domenica@iestpgildaballivian.edu.pe", foto: domenica, pdf:DOMENICA },
    { nombre: "CHIPANA TAGLE DENNIS DANIEL", correo: "chipana.dennis@iestpgildaballivian.edu.pe", foto: chipana, pdf:CHIPANA },
    { nombre: "FERNANDEZ CASTRO JORGE MARCELINO", correo: "fernandez.jorge@iestpgildaballivian.edu.pe", foto:fernandez1, pdf:FERNANDEZ },
    { nombre: "HERNANDEZ BECERRA GUILLERMO", correo: "hernandez.guillermo@iestpgildaballivian.edu.pe", foto: hernandez, pdf: HERNANDEZ },    
    { nombre: "MORENO MANCO ALFONSO CESAR", correo: "moreno.alfonso@iestpgildaballivian.edu.pe", foto: moreno, pdf: MORENO },    
    { nombre: "OSCCO PAREDES JAIME GREGORIO", correo: "oscco.jaime@iestpgildaballivian.edu.pe", foto: osco, pdf: OSCO },
    { nombre: "RUIZ DE CASTILLA DONGO MARIA DEL ROSARIO", correo: "ruizdecastilla.maria@iestpgildaballivian.edu.pe", foto: ruiz, pdf: RUIZ },    
    { nombre: "OLIVARES MANDUJANO MARICELA FRESIA", correo: "olivares.maricela@iestpgildaballivian.edu.pe", foto: olivares, pdf:OLIVARES },
  ],

  "Desarrollo de Sistemas": [
    { nombre: "HUANCA PACHAURI BENJAMIN", correo: "huanca.benjamin@iestpgildaballivian.edu.pe", foto: huanca, pdf: HUANCA },
    { nombre: "APARI VALENZUELA OSCAR", correo: "apari.oscar@iestpgildaballivian.edu.pe", foto: apari, pdf: APARI },    
    { nombre: "CARRASCO LINARES LIZARDO ALEJANDRO", correo: "carrasco.alejandro@iestpgildaballivian.edu.pe", foto: carrascolinares, pdf:CARRASCOLINARES },
    { nombre: "ESTRADA YNDIGOYEN EDUARDO LEON", correo: "estrada.eduardo@iestpgildaballivian.edu.pe", foto: estrada, pdf: ESTRADA },
    { nombre: "GALVEZ NIÑO DE GUZMAN KARINA", correo: "galvez.karina@iestpgildaballivian.edu.pe", foto: galvez, pdf:KARINA },
    { nombre: "GUTIERREZ BARAHONA JOSÉ DIÓMEDES", correo: "gutierrez.jose@iestpgildaballivian.edu.pe", foto: gutierrez, pdf: GUTIERREZ },
    { nombre: "HUANASCA RIVAS DAVID CORNELIO", correo: "huanasca.david@iestpgildaballivian.edu.pe", foto: huanasca, pdf: HUANASCA },    
    { nombre: "MONARES CHAVEZ MAURA BEATRIZ", correo: "monares.maura@iestpgildaballivian.edu.pe", foto: monares, pdf: MONARES },
    { nombre: "PADILLA OBREGON CESAR EDMUNDO", correo: "padilla.cesar@iestpgildaballivian.edu.pe", foto: padilla, pdf: PADILLA },
    { nombre: "PORTAL BAZAN PEDRO DE LOS ANGELES", correo: "portal.pedro@iestpgildaballivian.edu.pe", foto: portal, pdf: PORTAL },
    { nombre: "YAYA GOMEZ MARÍA EMILIA", correo: "yaya.maria@iestpgildaballivian.edu.pe", foto: yaya, pdf: YAYA },
    { nombre: "CORTEZ CAMACHO JOSE RICARDO", correo: "cortez.jose@iestpgildaballivian.edu.pe", foto: cortez, pdf: CORTEZ },
  ],



  "Construcción Civil": [
    { nombre: "AZAHUANCHE ASMAT VIRGINIA LIBERTAD", correo: "azahuanche.virginia@iestpgildaballivian.edu.pe", foto: azahuanche , pdf:AZAHUANCHE},
    { nombre: "ANTONIO PAZ SOLDAN AMADEO SIXTO", correo: "antonio.amadeo@iestpgildaballivian.edu.pe", foto: pazsoldan, pdf: PAZSOLDAN },    
    { nombre: "BASTIDAS PINO DIONI AMADOR", correo: "bastidas.dioni@iestpgildaballivian.edu.pe", foto: bastidas, pdf:BASTIDAS },
    { nombre: "GALLARDO MENDOZA JUAN CARLOS", correo: "gallardo.juan@iestpgildaballivian.edu.pe", foto: gallardo, pdf: GALLARDO },
    { nombre: "HUARHUA CONTRERAS ESTAQUIO", correo: "huarhua.eustaquio@iestpgildaballivian.edu.pe", foto: huarhua, pdf: HUARHUA },
    { nombre: "MEDINA OCHOA JOSE GONZALO", correo: "medina.jose@iestpgildaballivian.edu.pe", foto: medina, pdf:MEDINA },
    { nombre: "ZUÑIGA RONDINEL LEO", correo: "zuniga.leo@iestpgildaballivian.edu.pe", foto: zuñiga, pdf: ZUÑIGA},
    { nombre: "MANUEL HUACCHA HUAYTA", correo: "huaccha.manuel@iestpgildaballivian.edu.pe", foto: huaccha, pdf: HUACCHA},
  ],


  

  "Electricidad Industrial": [
    { nombre: "CARHUANCHO PALOMINO LUIS ENRIQUE", correo: "carhuancho.luis@iestpgildaballivian.edu.pe", foto: carhuancho, pdf:Carhuancho },
    { nombre: "FELIPE GUILLEN LUIS MIGUEL", correo: "felipe.luis@iestpgildaballivian.edu.pe", foto: defaultPhoto, pdf: GUILLEN },
    { nombre: "GARCIA TERAN PEDRO VEDA", correo: "garcia.pedro@iestpgildaballivian.edu.pe", foto: teran, pdf: TERAN },
    { nombre: "GUERRA CABALLERO CARLOS RAUL", correo: "guerra.carlosc@iestpgildaballivian.edu.pe", foto: guerra, pdf:GUERRA },
    { nombre: "HERRERA TRELLES JULIO CESAR", correo: "herrera.julio@iestpgildaballivian.edu.pe", foto: herrera, pdf: HERRERA },    
    { nombre: "MERA ANDIA JOSE LUIS", correo: "mera.jose@iestpgildaballivian.edu.pe", foto: mera, pdf: MERA },
    { nombre: "PUJAY ACEVEDO JOEL ELISEO", correo: "pujay.joel@iestpgildaballivian.edu.pe", foto: pujay, pdf:Pujay },    
    { nombre: "TALLA CONDESO ROBERTO EDGARDO", correo: "talla.roberto@iestpgildaballivian.edu.pe", foto: defaultPhoto, pdf: TALLA },
    { nombre: "VILLAVICENCIO RIVEROS EDWIN RICHARD", correo: "villavicencio.edwin@iestpgildaballivian.edu.pe", foto: villavicencioriveros, pdf:VILLAVICENCIORIVEROS },
    { nombre: "ALEJO PANEBRA MAURO JAVIER", correo: "alejo.mauro@iestpgildaballivian.edu.pe", foto: alejo, pdf: ALEJO },
    { nombre: "ACARO DUEÑAS ALEX MARCELINO", correo: "acaro.alex@iestpgildaballivian.edu.pe", foto: acaro, pdf: ACARO },

  ],

  "Electrónica Industrial": [
    { nombre: "ROJAS CAHUA LUIS ALBERTO", correo: "rojas.luis@iestpgildaballivian.edu.pe", foto: rojascahua, pdf: ROJASCAHUA },
    { nombre: "FERRO QUICAÑO JOSE LUIS", correo: "ferro.jose@iestpgildaballivian.edu.pe", foto: ferro, pdf: FERRO },
    { nombre: "GALLARDO LOPEZ ALEX NOE", correo: "gallardo.alex@iestpgildaballivian.edu.pe", foto: gallardolopez, pdf:GALLARDOLOPEZ },
    { nombre: "GUILLEN ROJAS ALFREDO", correo: "guillen.alfredo@iestpgildaballivian.edu.pe", foto: guillenrojas, pdf:GUILLENROJAS },
    { nombre: "HUAILLA ATAO DELIA CONCEPCIÓN", correo: "huailla.delia@iestpgildaballivian.edu.pe", foto: huailla, pdf: HUAILLA },
    { nombre: "INGA PEÑA AULO WILFREDO", correo: "inga.aulo@iestpgildaballivian.edu.pe", foto: auloinga, pdf: AULOINGA },
    { nombre: "MEZA RODRIGUEZ FELIX CELSO", correo: "meza.felix@iestpgildaballivian.edu.pe", foto: meza, pdf: MEZA},
    { nombre: "NOLASCO SANDOVAL LUIS ALFREDO", correo: "nolasco.luis@iestpgildaballivian.edu.pe", foto: nolasco, pdf: NOLASCO },
    { nombre: "RAMOS ROJAS ARTURO", correo: "ramos.arturo@iestpgildaballivian.edu.pe", foto: defaultPhoto, pdf:Ramos_Rojas },    
    { nombre: "UNSIHUAY TOVAR ROBERTO FLORENTINO", correo: "unsihuay.roberto@iestpgildaballivian.edu.pe", foto:unsihuay,pdf: UNSIHUAY },
    { nombre: "VELASQUEZ CABANILLAS HECTOR FELIPE", correo: "velasquez.hector@iestpgildaballivian.edu.pe", foto: velasquezcabanillas, pdf: VELASQUEZCABANILLAS },
    { nombre: "VILLAVICENCIO JIMENEZ SERGIO CARLOS ANDRES", correo: "villavicencio.sergio@iestpgildaballivian.edu.pe", foto: villavicencio, pdf:Villavicencio },
    { nombre: "DIAZ PERNIA JOSUE ", correo: "diaz.josue@iestpgildaballivian.edu.pe", foto: pernia, pdf:PERNIA },
  ],

  

  "Mecánica de Producción Industrial": [
    { nombre: "HUARACHA CASAS RIGOBERTO PERCY", correo: "huaracha.rigoberto@iestpgildaballivian.edu.pe", foto: huaracha, pdf: HUARACHA },
    { nombre: "CALDERON CORNELIO WILMER WASHINGTON", correo: "calderon.wilmer@iestpgildaballivian.edu.pe", foto: calderon, pdf:CALDERON },    
    { nombre: "GUTIERREZ TORRES CESAR EDISON", correo: "gutierrez.cesar@iestpgildaballivian.edu.pe", foto: gutierrez_c, pdf:GUTIERREZ_C },    
    { nombre: "JURADO GUILLEN NOSSER MARIANO", correo: "jurado.nosser@iestpgildaballivian.edu.pe", foto: nosser, pdf: NOSSER },
    { nombre: "MAMANI SANTA CRUZ ANA YOVANA", correo: "mamani.ana@iestpgildaballivian.edu.pe", foto: mamani, pdf:MAMANI },
    { nombre: "QUIHUI YNGA FRANCISCO", correo: "quihui.francisco@iestpgildaballivian.edu.pe", foto: quihui, pdf: QUIHUI },
    { nombre: "QUISPE FLORES NEIL", correo: "quispe.neil@iestpgildaballivian.edu.pe", foto: neil, pdf: NEIL },
    { nombre: "SORIA PEREZ EMILIA", correo: "soria.emilia@iestpgildaballivian.edu.pe", foto: soria, pdf: SORIA },
    { nombre: "SOSA MASGO MOISES EULOGIO", correo: "sosa.moises@iestpgildaballivian.edu.pe", foto: sosa, pdf: SOSA },
    { nombre: "VICENCIO RAMOS EFRAIN", correo: "vicencio.efrain@iestpgildaballivian.edu.pe", foto: ramos, pdf: RAMOS },
    { nombre: "SUAREZ LEANDRO JESUS ", correo: "suarez.jesus@iestpgildaballivian.edu.pe", foto: suarez, pdf: SUAREZ },
  ],

  "Mecatrónica Automotriz": [
    { nombre: "PALOMARES ANSELMO JIM ANDREW", correo: "palomares.jim@iestpgildaballivian.edu.pe", foto: palomares, pdf: PALOMARES },
    { nombre: "CABRERA NUÑEZ JORDAN FELIPE", correo: "cabrera.jordan@iestpgildaballivian.edu.pe", foto: cabrera, pdf: CABRERA },
    { nombre: "GASPAR PRADO JUAN WILLIAM", correo: "gaspar.juan@iestpgildaballivian.edu.pe", foto: gaspar, pdf: GASPAR },    
    { nombre: "PALOMINO RIOS DAVID ANGEL", correo: "palomino.david@iestpgildaballivian.edu.pe", foto: palomino, pdf:PALOMINO },
    { nombre: "PILLACA DIAZ TEODORO", correo: "pillaca.teodoro@iestpgildaballivian.edu.pe", foto: pillaca, pdf: PILLACA },
    { nombre: "ROJAS SALDAÑA ALFREDO MANUEL", correo: "rojas.alfredo@iestpgildaballivian.edu.pe", foto: rojas, pdf: ROJAS },
    { nombre: "CHOQUE CAYLLA MARIA JESUS", correo: "choque.maria@iestpgildaballivian.edu.pe", foto: choque, pdf:CHOQUE },
  ],

  "Docentes de Empleabilidad": [
    
    { nombre: "CAMARGO CAMERO JAVIER", correo: "camargo.javier@iestpgildaballivian.edu.pe", foto: camargo, pdf: CAMARGO },    
    { nombre: "EYZAGUIRRE ESPINO JULIO CESAR", correo: "eyzaguirre.julio@iestpgildaballivian.edu.pe", foto: eyzaguirre, pdf: EYZAGUIRRE },    
    { nombre: "LAGOS BAUTISTA GABY LUZ", correo: "lagos.gaby@iestpgildaballivian.edu.pe", foto: lagos, pdf: LAGOS },
    { nombre: "PAREJA PINTO FEDERICO ANTONIO", correo: "pareja.federico@iestpgildaballivian.edu.pe", foto: pareja, pdf: PAREJA },
    { nombre: "PEREZ MENDOZA LILA JESSICA", correo: "perez.lila@iestpgildaballivian.edu.pe", foto: perezmendoza, pdf: PEREZMENDOZA },
    { nombre: "PONCE TEJADA MARÍA DEL PILAR", correo: "ponce.maria@iestpgildaballivian.edu.pe", foto: defaultPhoto, pdf: PONCE },    
    { nombre: "ROSAS RETUERTO GOMEZ VLADIMIR HERNANI", correo: "rosasretuerto.vladimir@iestpgildaballivian.edu.pe", foto: defaultPhoto, pdf: VLADIMIR },
    { nombre: "SOLANO ZAPATA ELIZABETH DIANA", correo: "solano.elizabeth@iestpgildaballivian.edu.pe", foto: solano, pdf:SOLANO },
    { nombre: "ZÁRATE CLAROS YEFFERSON FRANKLIN", correo: "zarate.yefferson@iestpgildaballivian.edu.pe", foto: zarate, pdf:ZARATE },
  ],
};


const PlanaDocente = () => {
  const [selectedPdf, setSelectedPdf] = useState(null);

  useEffect(() => {
    AOS.init({ duration: 800 });
  }, []);

  const handleOpenPdf = (pdf) => {
    setSelectedPdf(pdf);
    
  };

  const handleClosePdf = () => {
    setSelectedPdf(null);
  };

  return (
    <section className="plana-docente-page">
      {/* Banner superior */}
      <div className="banner-docente">
        <div className="overlay"></div>
        <div className="text-center text-white">
          <h1 className="fw-bold">Plana Docente</h1>
          <p className="lead">
            Profesionales comprometidos con la excelencia educativa y tecnológica.
          </p>
        </div>
      </div>

      {/*  Contenido principal */}
      <div className="container py-5">
        {Object.keys(docentesData).map((programa, idx) => (
          <div key={idx} className="mb-5" data-aos="fade-up">
            <h2 className="programa-title">{programa}</h2>
            <div className="row g-4">
              {docentesData[programa].map((docente, i) => (
                <div className="col-6 col-md-4 col-lg-3" key={i} >
                  <div className="card-docente text-center">
                   <div className="foto-container">
                      {docente.pdf ? (
                        <img
                          src={docente.foto || defaultPhoto}
                          alt={docente.nombre}
                          className="foto-docente"
                          onClick={() => handleOpenPdf(docente.pdf)}
                          style={{ cursor: "pointer" }}
                        />
                      ) : (
                        <div className="falta-cv">
                          <img
                            src={docente.foto || defaultPhoto}
                            alt={docente.nombre}
                            className="foto-docente opacity-50"
                          />
                          <p className="text-danger fw-bold mt-2">Falta cargar CV</p>
                        </div>
                      )}
                    </div>

                    <div className="docente-info">
                      <h5>{docente.nombre}</h5>
                      <p className="correo">
                        <FaEnvelope className="me-2" />
                        {docente.correo}
                      </p>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        ))}
      </div>

      {/*  Modal PDF */}
      {selectedPdf && (
        <div className="pdf-modal" onClick={handleClosePdf}>
          <div
            className="pdf-modal-content-wide"
            onClick={(e) => e.stopPropagation()}
          >
            <button className="close-btn" onClick={handleClosePdf}>
              <FaTimes size={20} />
            </button>
            <iframe
              src={`${selectedPdf}#view=FitH`}
              title="CV Docente"
              className="pdf-full-view-wide"
            ></iframe>
          </div>
        </div>
      )}
    </section>
  );
};

export default PlanaDocente;

